import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxSpinnerModule } from 'ngx-spinner';

import { ToastModule } from 'primeng/toast';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { DrawerModule } from 'primeng/drawer';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { SsoComponent } from './components/sso/sso.component';
import { AppDialogService } from './services/app-dialog.service';
import { HttpErrorHandler } from './services/http-error-handler.service';
import { httpInterceptorProviders } from './services/http-interceptor';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonSharedModule } from './modules/shared/common-shared.module';

@NgModule({ declarations: [
        AppComponent,
        PageNotFoundComponent,
        SsoComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        AppRoutingModule,
        NgxSpinnerModule,
        ToastModule,
        DialogModule,
        DrawerModule,
        DynamicDialogModule,
        NgSelectModule,
        CommonSharedModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: true,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [HttpErrorHandler, { provide: DialogService, useClass: AppDialogService }, MessageService, httpInterceptorProviders, provideHttpClient(withInterceptorsFromDi()), providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: false } }, ripple: true })] })
export class AppModule { }
